import { Schema } from "effect";

export const MeResponse = Schema.Struct({
  teamId: Schema.String,
  teamName: Schema.String,
  userId: Schema.String,
  email: Schema.optional(Schema.String),
  firstName: Schema.optional(Schema.String),
  lastName: Schema.optional(Schema.String),
  permissionCount: Schema.Number,
});

export type MeResponse = typeof MeResponse.Type;
